<template>
  <CustomContainer customClass="transfer-design--wrapper content modal-scroll-area" elementType="section">
    <CustomText customClass="transfer-design--description" keyTranslation="transferDesignModalDescription"/>
    <CustomContainer :customClass="['transfer-design--options-scroll', { 'scroll-activated': isOverMaxLength }]" >
      <CustomContainer customClass="transfer-design--options">
        <CustomContainer
          :customClass="['transfer-design--option', { 'selected': isSelected(modelName) }]"
          v-for="(recipeData, modelName) in recipes"
          :key="modelName"
          @click="onSelect(modelName, recipeData)"
        >
          <CustomContainer
            customClass="transfer-design--image"
            :style="`background-image: url('${ $store.state.transferDesign.imageUrls[modelName] }')`"
          />
          <CustomContainer customClass="transfer-design--content">
            <CustomText customClass="transfer-design--name" :text="recipeData.displayName"/>
            <CustomContainer customClass="transfer-design--price"><currencyWrapper :priceRaw="prices[modelName]" /></CustomContainer>
            <CustomText customClass="transfer-design--text" v-show="recipeData.isPersonalizationInvalid" keyTranslation="transferDesignEmbroideryText"/>
          </CustomContainer>
        </CustomContainer>
      </CustomContainer>
    </CustomContainer>
  </CustomContainer>
</template>

<script>
import { Vue, Component } from 'vue-property-decorator';
import CustomContainer from '@/components/Globals/CustomContainer.vue';
import CustomText from '@/components/Globals/CustomText.vue';
import CustomImage from '@/components/Globals/CustomImage.vue';
import currencyWrapper from '@/components/Globals/CurrencyWrapper';

import designContent from '@/mixins/TransferDesign/DesignContent';

@Component({
  components: {
    CustomContainer,
    CustomText,
    CustomImage,
    currencyWrapper
  },
  mixins: [designContent],
})
export default class TransferDesignContent extends Vue {}
</script>